<template>
    <div v-if="(isSelf && !$store.getters['orgs/isAdmin']) || $store.getters['orgs/isAdmin']">
        <main-dropdown>
            <template slot-scope="context">
                <button @click="context.toggleOpen" class="text-gray-500 hover:text-primary-500 focus:outline-none focus:underline">
                    <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                        <path d="M12,10a2,2,0,1,0,2,2A2,2,0,0,0,12,10ZM5,10a2,2,0,1,0,2,2A2,2,0,0,0,5,10Zm14,0a2,2,0,1,0,2,2A2,2,0,0,0,19,10Z" />
                    </svg>
                </button>
                <transition
                    enter-active-class="transition-all duration-100 ease-out"
                    leave-active-class="transition-all duration-100 ease-in"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div v-if="context.open" class="absolute right-0 z-10 w-48 overflow-hidden origin-center bg-white border border-gray-200 rounded-md shadow-md top-6">
                        <modify-self v-if="isSelf" @leave="leave()" />
                        <modify-member v-else @modify="toggle(context)" @remove="remove()" />
                    </div>
                </transition>
            </template>
        </main-dropdown>
        <main-modal :open="open" @close="open = false">
            <div class="px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6">
                <div>
                    <div>
                        <h3 class="text-lg font-semibold leading-6 text-gray-900">
                            Change <span>{{ member.user.full_name }}</span
                            >'s account type
                        </h3>
                        <div class="mt-2">
                            <p class="text-sm leading-5 text-gray-600">
                                Choose what account type {{ member.user.full_name }} will have in the {{ $store.state.orgs.org.name }} organization.
                            </p>
                        </div>
                    </div>
                    <div class="block">
                        <div class="mt-2">
                            <div>
                                <label class="inline-flex items-center">
                                    <input type="radio" class="form-radio" v-model="role" name="admin" value="admin" />
                                    <span for="admin" class="ml-2">Admin</span>
                                </label>
                            </div>
                            <div>
                                <label class="inline-flex items-center">
                                    <input type="radio" class="form-radio" v-model="role" name="member" value="member" />
                                    <span for="member" class="ml-2">Member</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row-reverse mt-5">
                    <span class="flex rounded-md shadow-sm">
                        <button
                            @click="save"
                            type="button"
                            class="w-24 text-base font-medium leading-6 text-white transition duration-150 ease-in-out shadow-sm btn bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary sm:text-sm sm:leading-5"
                        >
                            Save
                        </button>
                    </span>
                    <span class="flex mr-2 rounded-md shadow-sm">
                        <button
                            @click="open = false"
                            type="button"
                            class="w-24 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 shadow-sm btn hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline sm:text-sm sm:leading-5"
                        >
                            Cancel
                        </button>
                    </span>
                </div>
            </div>
        </main-modal>
    </div>
</template>

<script>
import MainDropdown from '@/components/MainDropdown';
import MainModal from '@/components/MainModal';
import ModifySelf from '@/components/ModifySelf';
import ModifyMember from '@/components/ModifyMember';

export default {
    name: 'modify-org-user',
    components: { MainDropdown, MainModal, ModifyMember, ModifySelf },
    props: {
        member: Object,
    },
    data() {
        return {
            open: false,
            role: this.member.role,
        };
    },
    computed: {
        isSelf() {
            return this.member.user.id === this.$store.state.users.user.id;
        },
    },
    methods: {
        save() {
            this.open = false;
            this.$store.dispatch('orgs/update_member', { id: this.member.id, role: this.role });
        },
        remove() {
            this.$store.dispatch('orgs/remove_member', { id: this.member.id });
        },
        leave() {
            this.$store
                .dispatch('orgs/leave_org', { id: this.$store.state.users.user.id })
                .then(() => this.$router.go('/'))
                .catch(() => this.$router.go('/'));
        },
        toggle(context) {
            context.toggleOpen();
            this.open = true;
        },
    },
};
</script>
